import { DashboardService } from './services/dashboard.service';
import { UserDetails } from './models/userDetails.interface';
import { RegisterAccountComponent } from './components/account/register-account/register-account.component';
import { JournalEntry } from './models/Txn_JournalEntry';
import { ReportService } from './services/Acc_ReportService';
import { DariCalendarService } from './services/DariCalendar';
import { GL_Master } from './models/GL_Master';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { GL_MasterService } from './services/Acc_GL_Master.service';
import { UtilityService } from './services/Acc_Utility.service';
import { Acc_Txn_Service} from './services/Acc_Txn_Servcies';
import { AccountMappingService } from './services/AccountMappingService';
import { AppComponent } from './components/app/app.component';
import { NavMenuComponent } from './components/navmenu/navmenu.component';
import { HomeComponent, Dari } from './components/home/home.component';
import {MatCoreModule} from './components/mat-core/mat-core.module'
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { GlChildComponent } from './components/GLs/gl-child/gl-child.component';
import { GlMasterComponent } from './components/GLs/gl-master/gl-master.component';
import { GlChildEditComponent } from './components/Gls/gl-child-edit/gl-child-edit.component';
import { GlChildAddComponent } from './components/GLs/gl-child-add/gl-child-add.component';
import { GlMasterAddComponent } from './components/GLs/gl-master-add/gl-master-add.component';
import { Global} from './components/global';
import { StudentInvoiceComponent } from './components/TRNs/student-invoice/student-invoice.component';
import { StudentInvoiceTermComponent } from './components/TRNs/student-invoice-term/student-invoice-term.component';
import { InitialBalanceComponent } from './components/trns/initial-balance/initial-balance.component';
import { GlLedgerComponent } from './components/gls/gl-ledger/gl-ledger.component';
import { TrailBalanceComponent } from './components/reports/trail-balance/trail-balance.component';
import { DatePipe } from '@angular/common';
import { JournalEntryComponent } from './components/TRNs/journal-entry/journal-entry.component';
import { JournalListComponent } from './components/management/journal-list/journal-list.component';
import { FixAssetsComponent } from './components/TRNs/fix-assets/fix-assets.component';
import { AccountMappingComponent } from './components/settings/account-mapping/account-mapping.component';
import {StudentRecieveInvComponent } from './components/TRNs/student-recieve-inv/student-recieve-inv.component'
import { InvoiceService } from './services/Acc_InvoiceService';
import { LoginComponent } from './components/account/login/login.component';
import { ChangePasswordComponent } from './components/account/change-pass/change-pass.component';
import { ChangeProfileComponent } from './components/account/change-profile/change-profile.component';
import { SpinnerComponent} from './components/spinner/spinner.component';
import { UserService } from './services/user.service';
import { BaseService } from './services/base.service';
import { ConfigService } from './components/utils/config.service';
import { HttpModule, XHRBackend } from '@angular/http';
import { AuthenticateXHRBackend } from './components/authenticate-xhr.backend';
import { AuthGuard } from './components/auth.guard';
import { LogoutComponent } from './components/account/logout/logout.component';
import { IncomeStatementComponent } from './components/reports/income-statement/income-statement.component';
import { BalanceSheetComponent } from './components/reports/balance-sheet/balance-sheet.component';
import { TestComponent } from './components/test/test.component';
import { ExpenseEntryComponent } from './components/TRNs/expense-entry/expense-entry.component';
import { InvoiceListComponent } from './components/management/invoice-list/invoice-list.component';
import { InvoiceRemainListComponent } from './components/management/invoice-remain-list/invoice-remain-list.component';
import { StudentDiscountListComponent } from './components/management/student-discount-list/student-discount-list.component';
import { Expense_Service } from './services/Acc_Expense_Service';
import { ExpenseListComponent } from './components/management/expense-list/expense-list.component';
import { CurrencyMaskModule } from "ng2-currency-mask";
import { EditInvoiceDialogComponent } from './components/management/edit-invoice-dialog/edit-invoice-dialog.component';
import { EditInvoiceTermDialogComponent } from './components/management/edit-invoice-term-dialog/edit-invoice-term-dialog.component';
import { MatFormFieldModule, MatDialogModule, MatInputModule, MatButtonModule } from '@angular/material';
import { ExcelService } from './services/ExcelService';
import { EditExpenseDialogComponent } from './components/management/edit-expense-dialog/edit-expense-dialog.component';
import { IncomeEntryComponent } from './components/TRNs/income-entry/income-entry.component';
import { Income_Service } from './services/Acc_Income_Service';
import { ImportStudentsComponent } from './components/settings/import-students/import-students.component';
import { StudentFinanceReportComponent } from './components/reports/student-finance-report/student-finance-report.component';
import { FeeComponent } from './components/fee/fee/fee.component';
import { FeeAddComponent } from './components/fee/fee-add/fee-add.component';
import { FeeService } from './services/FeeService';
import { FeeEditDialogComponent } from './components/fee/fee-edit-dialog/fee-edit-dialog.component';

import { DiscountComponent } from './components/discount/discount/discount.component';
import { DiscountAddComponent } from './components/discount/discount-add/discount-add.component';
import { DiscountService } from './services/DiscountService';
import { DiscountEditDialogComponent } from './components/discount/discount-edit-dialog/discount-edit-dialog.component';

import { PaidFeesModalComponent } from './components/TRNs/student-invoice/paid-fees-modal/paid-fees-modal.component';
import { StudentListComponent } from './components/reports/student-list/student-list.component';
import { SumMoneyComponent } from './components/reports/sum-money/sum-money.component';
import { NewCardComponent } from './components/card/new-card/new-card.component';
import { CardListComponent } from './components/card/card-list/card-list.component';
import { UserListComponent } from './components/user/user-list.component';
import { AccessKeyUserComponent } from './components/settings/access-key-user/access-key-user.component';
import { FixAmountComponent } from './components/settings/fix-amount/fix-amount.component';
import { EditExpenseStatusDialogComponent } from './components/management/edit-expense-status-dialog/edit-expense-status-dialog.component';
import { UserAddComponent } from './components/user/user-add/user-add.component';

import { JournalEditComponent } from './components/management/journal-edit/journal-edit.component';
import { JournalStatusEditComponent } from './components/management/journal-status-edit/journal-status-edit.component';
import { IncomeStatementAccountComponent } from './components/reports/income-statement-account/income-statement-account.component';



@NgModule({
  declarations: [
    AppComponent,
    NavMenuComponent,
    HomeComponent,
    GlChildComponent,
    GlChildAddComponent,
    GlMasterComponent,
    GlChildEditComponent,
    GlMasterAddComponent,
    StudentInvoiceComponent,    
    StudentInvoiceTermComponent,
    InitialBalanceComponent,
    GlLedgerComponent,
    TrailBalanceComponent,
    JournalEntryComponent,
    JournalListComponent,
    FixAssetsComponent,
    AccountMappingComponent,
    StudentRecieveInvComponent,
    LoginComponent,
    ChangePasswordComponent,
    ChangeProfileComponent,
    RegisterAccountComponent,
    SpinnerComponent,
    IncomeStatementComponent,
    IncomeStatementAccountComponent,
    BalanceSheetComponent,
    TestComponent,
    InvoiceListComponent,
    InvoiceRemainListComponent,
    StudentDiscountListComponent,
    ExpenseListComponent,
    ExpenseEntryComponent,
    EditInvoiceDialogComponent,
    EditInvoiceTermDialogComponent,
    EditExpenseDialogComponent,
    EditExpenseStatusDialogComponent,
    IncomeEntryComponent,
    ImportStudentsComponent,
    StudentFinanceReportComponent,
    FeeComponent,
    FeeAddComponent,
    FeeEditDialogComponent,
    DiscountComponent,
    DiscountAddComponent,
    UserAddComponent,
    DiscountEditDialogComponent,
    PaidFeesModalComponent,
    StudentListComponent,
    SumMoneyComponent,
    NewCardComponent,
    AccessKeyUserComponent,
    CardListComponent,
    UserListComponent,
    FixAmountComponent,
    JournalListComponent,
    JournalStatusEditComponent,
    JournalEditComponent
  ],
  imports: [
    MatFormFieldModule,
    MatDialogModule,
    MatInputModule,
    MatButtonModule,
    MatCoreModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    HttpModule,
    CurrencyMaskModule,
    RouterModule.forRoot([
      // { path: '', redirectTo: 'home', pathMatch: 'full' },
      { path: 'login', component: LoginComponent },
      { path: 'change-pass', component: ChangePasswordComponent },
      { path: 'change-profile', component: ChangeProfileComponent },
      { path: 'home', component: HomeComponent },
      { path: 'gl_master', component: GlMasterComponent, canActivate: [AuthGuard] },
      { path: 'gl_master/new', component: GlMasterAddComponent, canActivate: [AuthGuard] },
      { path: 'gl_master/:gL_Code', component: GlChildComponent, canActivate: [AuthGuard] },
      { path: 'gl_child/new/:gL_Code', component: GlChildAddComponent, canActivate: [AuthGuard] },
      { path: 'gl_ledger/:gL_Code', component: GlLedgerComponent, canActivate: [AuthGuard] },
      { path: 'student-invoice', component: StudentInvoiceComponent, canActivate: [AuthGuard] },
      { path: 'student-invoice-term', component: StudentInvoiceTermComponent, canActivate: [AuthGuard] },
      { path: 'student-rec_inv', component: StudentRecieveInvComponent, canActivate: [AuthGuard] },
      { path: 'gl_child/edit/:gL_Code/:gL_Master/:gL_ChildDesc/:gL_ChildDesc_en/:stDepartmentID/:gL_ChildDepName', component: GlChildEditComponent, canActivate: [AuthGuard] },
      { path: 'journal-entry', component: JournalEntryComponent, canActivate: [AuthGuard] },
      { path: 'journal-list', component: JournalListComponent, canActivate: [AuthGuard] },
      { path: 'fixAssets', component: FixAssetsComponent, canActivate: [AuthGuard] },
      { path: 'expense-entry', component: ExpenseEntryComponent, canActivate: [AuthGuard] },
      { path: 'income-entry', component: IncomeEntryComponent, canActivate: [AuthGuard] },
      { path: 'invoice-list', component: InvoiceListComponent, canActivate: [AuthGuard] },
      { path: 'invoice-remain-list', component: InvoiceRemainListComponent, canActivate: [AuthGuard] },
      { path: 'student-discount-list', component: StudentDiscountListComponent, canActivate: [AuthGuard] },
      { path: 'expense-list', component: ExpenseListComponent, canActivate: [AuthGuard] },
      { path: 'reports/trail-balance', component: TrailBalanceComponent, canActivate: [AuthGuard] },
      { path: 'reports/income-statement', component: IncomeStatementComponent, canActivate: [AuthGuard] },
      { path: 'reports/income-statement-account', component: IncomeStatementAccountComponent, canActivate: [AuthGuard] },
      { path: 'reports/balance-sheet', component: BalanceSheetComponent, canActivate: [AuthGuard] },
      { path: 'reports/student-finance-report', component: StudentFinanceReportComponent, canActivate: [AuthGuard] },
      { path: 'settings/account-map', component: AccountMappingComponent, canActivate: [AuthGuard] },
      { path: 'settings/access-key-user', component: AccessKeyUserComponent, canActivate: [AuthGuard] },
      { path: 'settings/register-account', component: RegisterAccountComponent },
      { path: 'settings/import-students', component: ImportStudentsComponent },
      { path: 'settings/fix-amount', component: FixAmountComponent },
      
      { path: 'fee', component: FeeComponent, canActivate: [AuthGuard] },
      { path: 'fee-add', component: FeeAddComponent, canActivate: [AuthGuard] },
      { path: 'discount', component: DiscountComponent, canActivate: [AuthGuard] },
      { path: 'discount-add', component: DiscountAddComponent, canActivate: [AuthGuard] },
      { path: 'user-add', component: UserAddComponent, canActivate: [AuthGuard] },      
      { path: 'reports/student-list', component: StudentListComponent, canActivate: [AuthGuard] },
      { path: 'reports/sum-money', component: SumMoneyComponent, canActivate: [AuthGuard] },
      { path: 'cards/new-card', component: NewCardComponent, canActivate: [AuthGuard] },
      { path: 'cards/card-list', component: CardListComponent, canActivate: [AuthGuard] },
      { path: 'user/user-list', component: UserListComponent, canActivate: [AuthGuard] },
      { path: 'reports/test', component: TestComponent },
      { path: '**', component: HomeComponent ,canActivate: [AuthGuard] }
    ])
  ],
  entryComponents: [
    EditInvoiceDialogComponent,
    EditInvoiceTermDialogComponent,
    EditExpenseDialogComponent,
    EditExpenseStatusDialogComponent,
    FeeEditDialogComponent,
    DiscountEditDialogComponent,
    PaidFeesModalComponent,
    JournalEditComponent,
    JournalStatusEditComponent,
  ],
  providers: [
    //{provide: MAT_DATE_LOCALE, useValue: 'fa-IR'},
    HttpModule,
    GL_MasterService,
    UtilityService,
    Acc_Txn_Service,
    ReportService,
    Global,
    DariCalendarService,
    AccountMappingService,
    Expense_Service,
    Income_Service,
    InvoiceService,
    DatePipe,
    FeeService,
    DiscountService,
    UserService,
    DashboardService,
    ConfigService,
    ExcelService,
   { 
    provide: XHRBackend, 
    useClass: AuthenticateXHRBackend
  },
  AuthGuard
],
  bootstrap: [AppComponent]
})
export class AppModule {
 }





// WEBPACK FOOTER //
// ./src/app/app.module.ts